import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ReportsRoutingModule} from "./reports-routing.module";
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {ReportDashboardComponent} from './report-dashboard/report-dashboard.component';
import {SharedModule} from "../shared/shared.module";
import {WeeklyReportsComponent} from './ops-reports/weekly-reports/weekly-reports.component';
import {PrettyJsonModule} from "angular2-prettyjson";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BirthdayReportsComponent} from './ops-reports/birthday-reports/birthday-reports.component';
import {ImpactReportsComponent} from './education-reports/impact-reports/impact-reports.component';
import {ImpactReportCounselingComponent} from './counselling-reports/impact-report-counseling/impact-report-counseling.component';
//import {ViewImpactReportCounselingComponent} from './counselling-reports/view-counseling-impact-report/view-impact-report-counseling.component';


import {
  EducationImpactReportTableComponent
} from './education-reports/education-impact-report-table/education-impact-report-table.component';
import {ReportCardTableComponent} from "./education-reports/report-card-table/report-card-table.component";
import {AttendanceReportComponent} from './education-reports/attendance-report/attendance-report.component';
import {ChartDisplayComponent} from './app-chart-display/chart-display.component';
import {ApexBarGraphComponent} from './apex-bar-graph/apex-bar-graph.component';

import { DragDropModule} from '@angular/cdk/drag-drop';
import {UnitReportComponent} from './ops-reports/unit-report/unit-report.component';
import {TreatmentDurationComponent} from './ops-reports/treatment-duration/treatment-duration.component';
import {LocationStateReportComponent} from './ops-reports/location-state-report/location-state-report.component';
import {DynamicTableComponent} from "./ops-reports/dynamic-table/dynamic-table.component";
import {ChildReportComponent} from "./ops-reports/child-report/child-report.component";
import {ChildReportFullDataComponent} from "./ops-reports/child-report-full-data/child-report-full-data.component";
import {AdmissionRecordsComponent} from "./ops-reports/admission-records/admission-records.component";
import {ProgressComponent} from "./counselling-reports/progress/progress.component";
import {ChallengesComponent} from "./counselling-reports/challenges/challenges.component";
import {InterventionComponent} from "./counselling-reports/intervention/intervention.component";
import {FollowUpComponent} from "./counselling-reports/follow-up/follow-up.component";
import {
  CounselingImpactReportTableComponent
} from "./counselling-reports/counseling-impact-report-table/counseling-impact-report-table.component";
import {ChallengesTableComponent} from "./counselling-reports/challenges-table/challenges-table.component";
import {InterventionTableComponent} from "./counselling-reports/intervention-table/intervention-table.component";
import {ProgressTableComponent} from "./counselling-reports/progress-table/progress-table.component";
import {AllergyTypeReportComponent} from "./ops-reports/allergy-type-report/allergy-type-report.component";
import {BloodGroupReportComponent} from "./ops-reports/blood-group-report/blood-group-report.component";
import {GenderCountReportComponent} from "./ops-reports/gender-count-report/gender-count-report.component";
import {HospitalReportComponent} from "./ops-reports/hospital-report/hospital-report.component";
import {AgeGroupReportComponent} from "./ops-reports/age-group-report/age-group-report.component";
import {HospitalCountReportComponent} from "./ops-reports/hospital-count-report/hospital-count-report.component";
import {ChildCaseStudyComponent} from "./ops-reports/child-case-study/child-case-study.component";
import {CountTableComponent} from "./ops-reports/count-table/count-table.component";
import {
  AddChildCaseStudyComponent
} from "./ops-reports/child-case-study/add-child-case-study/add-child-case-study.component";
import { ViewChildCaseStudyComponent } from './child-case-study/view-child-case-study/view-child-case-study.component';
import {ApexPiechartComponent} from "./apex-piechart/apex-piechart.component";
import { EducationLogTableComponent } from './education-log-table/education-log-table.component';
import { CounsellingLogTableComponent } from './counselling-log-table/counselling-log-table.component';
import { AddCounsellingLogComponent } from './counselling-log-table/add-counselling-log/add-counselling-log.component';
import { AddEducationLogComponent } from './education-log-table/add-education-log/add-education-log.component';
import { CounsellingSessionCountReportComponent } from './counselling-session-count-report/counselling-session-count-report.component';
import { LogVerifyDialogComponent } from './log-verify-dialog/log-verify-dialog.component';
import { ComparisonInterventionComponent } from './comparison-intervention/comparison-intervention.component';
import { InterventionBComponent } from './counselling-reports/intervention-b/intervention-b.component';
import { EducationCountReportComponent } from './education-reports/education-count-report/education-count-report.component';
import {
  ViewImpactReportCounselingComponent
} from "./counselling-reports/view-counseling-impact-report/view-impact-report-counseling.component";
import {
  ViewImpactReportsComponent
} from "./education-reports/view-education-impact-report/view-impact-reports.component";
import { CentreRankingComponent } from './centre-ranking/centre-ranking.component';
import { OccupancyComponent } from './occupancy/occupancy.component';
import { CustomUnitReportComponent } from './custom-unit-report/custom-unit-report.component';
import { FollowupSessionsOverviewComponent } from './counselling-reports/followup-sessions-overview/followup-sessions-overview.component';
import {MatListModule} from "@angular/material/list";
import { EducationFollowUpOverviewComponent } from './education-follow-up-overview/education-follow-up-overview.component';
import { CounsellingOverview2Component } from './counselling-reports/counselling-overview2/counselling-overview2.component';
import { EducationMixSessionReportComponent } from './education-reports/education-mix-session-report/education-mix-session-report.component';
import { DischargeReasonReportComponent } from './ops-reports/discharge-reason-report/discharge-reason-report.component';
import {NgxPrintDirective} from "ngx-print";
import {ApexBarGraph2Component} from "./apex-bar-graph2/apex-bar-graph2.component";
import {ApexBarGraph3Component} from "./apex-bar-graph3/apex-bar-graph3.component";
import { ChildCaseStudyViewComponent } from './ops-reports/child-case-study/child-case-study-view/child-case-study-view.component';
import { HospitalWiseOccupancyComponent } from './ops-reports/hospital-wise-occupancy/hospital-wise-occupancy.component';
import { OccupancyReportsComponent } from './ops-reports/occupancy-reports/occupancy-reports.component';
import { DailyChildOccupancyComponent } from './ops-reports/daily-child-occupancy/daily-child-occupancy.component';
import { AllDailyChildOccupancyComponent } from './ops-reports/occupancy-reports/all-daily-child-occupancy/all-daily-child-occupancy.component';
import {EducationModule} from "../education/education.module";
import { HighlightComponent } from './ops-reports/highlight/highlight.component';
import { AddHeighlightComponent } from './ops-reports/highlight/add-heighlight/add-heighlight.component';
import { ViewHighlightComponent } from './ops-reports/highlight/view-highlight/view-highlight.component';
import { EditHighlightItemComponent } from './ops-reports/highlight/edit-highlight-item/edit-highlight-item.component';
import { EfficiencyReportComponent } from './ops-reports/efficiency-report/efficiency-report.component';

import {
  CenterHighlightViewComponent
} from "./ops-reports/highlight/center-heighlight/center-highlight-view/center-highlight-view.component";
import {
  AddCenterHighlightComponent
} from "./ops-reports/highlight/center-heighlight/add-center-highlight/add-center-highlight.component";
import { EditCenterHighlightItemComponent } from './ops-reports/highlight/center-heighlight/edit-center-highlight-item/edit-center-highlight-item.component';
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatChipsModule} from "@angular/material/chips";
import {AdcTempReportComponent} from "./ops-reports/adc-temp-report/adc-temp-report.component";
import {
  CenterHighlightListComponent
} from "./ops-reports/highlight/center-heighlight/center-highlight-list/center-highlight-list.component";
import {ReportCard} from "./education-reports/report-card/report-card.component";
import { AddReportCardTypeComponent } from './education-reports/report-card/add-report-card-type/add-report-card-type.component';
import {GuardianReportComponent} from "./ops-reports/guardian-report/guardian-report.component";
import { DailyInventoryCountReportComponent } from './daily-inventory-count-report/daily-inventory-count-report.component';
import { CounsellingSessionsCountComponent } from './counselling-reports/counselling-sessions-count/counselling-sessions-count.component';
import { EducationHightlightReportComponent } from './education-reports/education-hightlight-report/education-hightlight-report.component';
import {ComponentsModule} from "../shared/components/components.module";
import { EducationPresentationComponent } from './education-reports/education-presentation/education-presentation.component';
import { ManageLearningConceptsDialogComponent } from './education-reports/education-presentation/manage-learning-concepts-dialog/manage-learning-concepts-dialog.component';
import {EducationMisReposrtComponent} from "./education-reports/education-mis-reposrt/education-mis-reposrt.component";
import { EducationPresentationListComponent } from './education-reports/education-presentation-list/education-presentation-list.component';
import { EducationSessionCountsNewComponent } from './education-reports/education-session-counts-new/education-session-counts-new.component';
import { AddmissionLogHistoryComponent } from './ops-reports/addmission-log-history/addmission-log-history.component';
import { SessionCountReportComponent } from './ops-reports/session-count-report/session-count-report.component';
import { CounsellingPresentationListComponent } from './counselling-reports/Counselling Presentation/counselling-presentation-list/counselling-presentation-list.component';
import { CounsellingPresentationComponent } from './counselling-reports/Counselling Presentation/counselling-presentation/counselling-presentation.component';
import {CounselingModule} from "../counseling/counseling.module";
import {MisCounselling2Component} from "./counselling-reports/mis-counselling2/mis-counselling2.component";
import { EducationPhotoGalleryComponent } from './education-reports/education-presentation/education-photo-gallery/education-photo-gallery.component';
import { CounsellingAssessmentChartsComponent } from './counselling-reports/counselling-assessment-charts/counselling-assessment-charts.component';
import { RevisedChildReportComponent } from './ops-reports/revised-child-report/revised-child-report.component';
import { AnnualImpactReportComponent } from './annual-impact-report/annual-impact-report.component';
import { AnnualImpactReportTableComponent } from './annual-impact-report/annual-impact-report-table/annual-impact-report-table.component';
import { AverageStayReportComponent } from './ops-reports/average-stay-report/average-stay-report.component';
import { NarrativeImpactReportComponent } from './narrative-impact-report/narrative-impact-report.component';
import { NarrativeImpactReportTableComponent } from './narrative-impact-report/narrative-impact-report-table/narrative-impact-report-table.component';
import { CollageEditorComponent } from './narrative-impact-report/collage-editor/collage-editor.component';
import { OmShantiReportComponent } from './ops-reports/om-shanti-report/om-shanti-report.component';

@NgModule({
  declarations: [
    DynamicTableComponent,
    ReportDashboardComponent,
    ChildReportComponent,
    WeeklyReportsComponent,
    ChildReportFullDataComponent,
    AdmissionRecordsComponent,
    BirthdayReportsComponent,
    ImpactReportsComponent,
    ViewImpactReportsComponent,
    ImpactReportCounselingComponent,
    ViewImpactReportCounselingComponent,
    ReportCardTableComponent,
    ProgressComponent,
    ChallengesComponent,
    InterventionComponent,
    FollowUpComponent,
    EducationImpactReportTableComponent,
    AttendanceReportComponent,
    CounselingImpactReportTableComponent,
    ChallengesTableComponent,
    InterventionTableComponent,
    ProgressTableComponent,
    AttendanceReportComponent,
    ChartDisplayComponent,
    ApexBarGraphComponent,
    AllergyTypeReportComponent,
    BloodGroupReportComponent,
    GenderCountReportComponent,
    UnitReportComponent,
    ReportCard,
    HospitalReportComponent,
    AgeGroupReportComponent,
    HospitalCountReportComponent,
    TreatmentDurationComponent,
    GuardianReportComponent,
    LocationStateReportComponent,
    ChildCaseStudyComponent,
    AddChildCaseStudyComponent,
    CountTableComponent,
    ViewChildCaseStudyComponent,
    ApexPiechartComponent,
    EducationLogTableComponent,
    CounsellingLogTableComponent,
    AddCounsellingLogComponent,
    AddEducationLogComponent,
    CounsellingSessionCountReportComponent,
    LogVerifyDialogComponent,
    ComparisonInterventionComponent,
    InterventionBComponent,
    EducationCountReportComponent,
    CentreRankingComponent,
    EducationMisReposrtComponent,
    EducationPresentationListComponent,

    OccupancyComponent,
    CustomUnitReportComponent,
    FollowupSessionsOverviewComponent,
    EducationFollowUpOverviewComponent,
    CounsellingOverview2Component,
    EducationMixSessionReportComponent,
    DischargeReasonReportComponent,
    ApexBarGraph2Component,
    ApexBarGraph3Component,
    ChildCaseStudyViewComponent,
    HospitalWiseOccupancyComponent,
    OccupancyReportsComponent,
    DailyChildOccupancyComponent,
    AllDailyChildOccupancyComponent,
    HighlightComponent,
    AddHeighlightComponent,
    ViewHighlightComponent,
    EditHighlightItemComponent,
    EfficiencyReportComponent,
    AdcTempReportComponent,
    EditCenterHighlightItemComponent,
    CenterHighlightViewComponent,
    AddCenterHighlightComponent,
    CenterHighlightListComponent,
    AddReportCardTypeComponent,
    DailyInventoryCountReportComponent,
    CounsellingSessionsCountComponent,
    EducationHightlightReportComponent,
    EducationPresentationComponent,
    ManageLearningConceptsDialogComponent,
    EducationSessionCountsNewComponent,
    AddmissionLogHistoryComponent,
    SessionCountReportComponent,
    CounsellingPresentationListComponent,
    CounsellingPresentationComponent,
    MisCounselling2Component,
    EducationPhotoGalleryComponent,
    CounsellingAssessmentChartsComponent,
    RevisedChildReportComponent,
    AnnualImpactReportComponent,
    AnnualImpactReportTableComponent,
    AverageStayReportComponent,
    NarrativeImpactReportComponent,
    NarrativeImpactReportTableComponent,
    CollageEditorComponent,
    OmShantiReportComponent,
  ],
  exports: [
    AdmissionRecordsComponent,
    SessionCountReportComponent,
    EducationPhotoGalleryComponent,
    HighlightComponent
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatChipsModule,
    PrettyJsonModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    DragDropModule,
    MatListModule,
    NgxPrintDirective,
    EducationModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    ComponentsModule,
    CounselingModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportsModule {
}
